import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HttpErrorResponse, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HsgOidcManagerService } from '@hhsg/hsg-asc';

import { Constants } from '../utilities/constants.util';
import { RouteUtil } from '../utilities/route.util';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private _router: Router, private _oidcManager: HsgOidcManagerService, private _tokenService: HttpXsrfTokenExtractor) { }

    private async handleAuthError(err: HttpErrorResponse, token: string): Promise<any> {
        if (token == undefined || token == null || token == '') {
            await this._router.navigateByUrl(`logout`);       
        } else {
            switch(err.status) {
                case 401:
                case 403:
                case 503: {
                    await this._router.navigateByUrl(`unauthorized`);
                    break;
                }
                default: { 
// await this._router.navigateByUrl(`logout`);
                    break;
                }
            }              
        }
        
        return throwError(err);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Grab the token from the OIDC session.
        let token = this._oidcManager.getToken();        
        
        // If not token is available then try to get the token from session.        
        if (token == '') {
            // This should only occur when the user has either just logged in or
            // is not authorized.
            token = sessionStorage.getItem(Constants.TokenName);
            if (token == null || token == undefined) {
                // This should be reached when the session is not authorized.
                token = '';
            }
        }

        let xsrfToken = this._tokenService.getToken();
        
        if (!xsrfToken) {
            xsrfToken = '';
        }

        let hacid: string = "";

        if (RouteUtil.isHuronAdmin()) { 
            hacid = sessionStorage.getItem(Constants.HuronAdminClientId); 
      
            if (!hacid) { 
                hacid = ""; 
            }
        }

        var header: HttpHeaders;

        header = new HttpHeaders({
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
            'Hacid': hacid,
            'X-XSRF-TOKEN': xsrfToken
        });
             
        const authReq = req.clone({ headers: header, withCredentials: true });
        
        return next.handle(authReq).pipe(catchError(err => this.handleAuthError(err, token)));
    }
}
